"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  formName: {
    title: {
      en: 'Form name',
      ru: 'Название формы'
    },
    category: 'Main',
    control: 'input'
  },
  successMessage: {
    title: {
      en: 'Success message',
      ru: 'Сообщение об успешной отправке'
    },
    category: 'Main',
    control: 'input',
    weight: 1
  },
  errorMessage: {
    title: {
      en: 'Error message',
      ru: 'Сообщение в случае ошибки'
    },
    category: 'Main',
    control: 'input',
    weight: 1
  }
};
exports["default"] = _default;